import {
    CONTROL_KITCHEN_ROUTE,
    MERCHANT_MENU_PLANNING_WEEK_MENU_ROUTE,
    MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE,
    MERCHANT_PRODUCTION_MEETING_SERVICE_VIEW_ROUTE,
    MERCHANT_PRODUCTION_PLANNING_ROUTE,
    MERCHANT_PRODUCTION_POS_PURCHASES_ROUTE,
    MERCHANT_PRODUCTION_ROUTE,
    MERCHANT_PRODUCTION_TAKEAWAY_ROUTE,
    MERCHANT_REPORTS_MENU_PLANNING_ROUTE,
    MERCHANT_REPORTS_ROUTE,
    SURVEY_ROUTE,
} from "../../../../constants/routes"
import { faCheckToSlot, faFaceSmile, faHome, faShieldCheck, faUtensils } from "@fortawesome/pro-light-svg-icons"

import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"

type Props = Readonly<{}>

export function MerchantReportNavItems({}: Props) {
    return (
        <>
            <LocalizedStrict id="merchant-nav-item-home">
                <NavMenuItem icon={faHome} dest={MERCHANT_REPORTS_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-production" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faCheckToSlot}
                    dest={MERCHANT_PRODUCTION_ROUTE}
                    title="Production"
                    dataTourId="merchant-product-tour-nav-production"
                >
                    <LocalizedStrict id="merchant-nav-item-production-planning">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_PLANNING_ROUTE}>Planning</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-production-meeting-service">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE}>
                            Meeting service
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-production-meeting-service-view">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_MEETING_SERVICE_VIEW_ROUTE}>
                            Production view
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-production-takeaway">
                        <NavMenuSubItem
                            route={MERCHANT_PRODUCTION_TAKEAWAY_ROUTE}
                            dataTourId="takeaway-announcement-tour-nav-takeaway"
                        >
                            Takeaway
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-production-pos-purchases">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_POS_PURCHASES_ROUTE}>POS purchases</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-group-menu-planning" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faUtensils}
                    dest={MERCHANT_REPORTS_MENU_PLANNING_ROUTE}
                    title="Menu planning"
                    dataTourId="merchant-product-tour-nav-menu-planning"
                >
                    <LocalizedStrict id="merchant-nav-item-menu-planning">
                        <NavMenuSubItem route={MERCHANT_REPORTS_MENU_PLANNING_ROUTE}>Menu planning</NavMenuSubItem>
                    </LocalizedStrict>
                    {/* Matches the route registration in router.tsx - the page only exists on Local/Test. */}
                    <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test]}>
                        <LocalizedStrict id="merchant-nav-item-menu-planning-v2">
                            <NavMenuSubItem route={MERCHANT_MENU_PLANNING_WEEK_MENU_ROUTE}>
                                Menu planning v2
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-purchase-control">
                <NavMenuItem
                    icon={faShieldCheck}
                    dest={CONTROL_KITCHEN_ROUTE}
                    dataTourId="merchant-product-tour-nav-purchase-control"
                >
                    Purchase control
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-survey">
                <NavMenuItem icon={faFaceSmile} dest={SURVEY_ROUTE} dataTourId="merchant-product-tour-nav-survey">
                    Survey
                </NavMenuItem>
            </LocalizedStrict>
        </>
    )
}
